module.exports = __webpack_public_path__ + "static/media/gameboxo.edff34dc.svg";